module.exports = __webpack_public_path__ + "static/logo2-61bc7085c39ca538115c9ea7075cd42d.png";